import { GatsbyImage } from 'gatsby-plugin-image';
import styled, { css } from 'styled-components';

import { Icon } from '@powdr/components';
import {
  ThemeProps as Prop, Breakpoints, Components,
  FontSize,
  FontFamily,
} from '@powdr/constants';
import { getFontStyles, themeUtil } from '@powdr/utils';

const CPNT = Components.HOTSPOT_GROUP;
const MOBILE_MAP_MIN_WIDTH_PX = 960;

export const StyledHotspotImage = styled.div`
  display: grid;
  position: relative;
  min-width: 0;
  max-width: 100%;
`;

export const MapScrollContainer = styled.div`
  grid-area: 1/1;

  ${({ $isMobileHorizontalScroll, $isModalOpen }) => {
    if (!$isMobileHorizontalScroll) {
      return css`display: contents;`;
    }

    return css`
      ${Breakpoints.desktopOnly(css`
        display: contents;
      `)}

      ${Breakpoints.mobile(css`
        width: 100vw;
        max-width: 100vw;
        margin-left: calc(50% - 50vw);
        overflow-x: ${$isModalOpen ? 'hidden' : 'auto'};
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
        overscroll-behavior-x: contain;
      `)}
    `;
  }}
`;

export const MapCanvas = styled.div`
  display: grid;
  width: 100%;
  height: 100%;

  ${({ $isMobileHorizontalScroll }) => {
    if (!$isMobileHorizontalScroll) {
      return css`display: contents;`;
    }

    return css`
      ${Breakpoints.desktopOnly(css`
        display: contents;
      `)}

      ${Breakpoints.mobile(css`
        min-width: ${MOBILE_MAP_MIN_WIDTH_PX}px;
      `)}
    `;
  }}
`;

export const Image = styled(GatsbyImage)`
  grid-area: 1/1;
  width: 100%;

  img {
    max-width: none;
  }
`;

export const HotspotsContainer = styled.div`
  position: relative;
  grid-area: 1/1;
  height: 100%;
  width: 100%;
`;

export const HotspotListContainer = styled.div`
  position: relative;
  grid-area: 1/1;
`;

export const HotspotList = styled.ul`
  width: 100%;
  height: 100%;
  margin-top: 10px;
`;

export const HotspotListItem = styled.li`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
  padding: 0 15px;
  width: 50%;
`;

export const ItemTitle = styled.p`
  ${() => getFontStyles(FontFamily.PRIMARY_FONT, FontSize.REG50, undefined, undefined)};
  line-height: 1;
  margin-bottom: 10px;
  text-align: center;
`;

export const ItemIcon = styled(Icon)`
  svg {
    fill: ${({ colorProfile }) => themeUtil(Prop.ICON, CPNT, colorProfile)};
    color: ${({ colorProfile }) => themeUtil(Prop.ICON, CPNT, colorProfile)};
  }
`;

export const Hotspot = styled.div`
  position: absolute;
  top: ${({ iconVerticalCoordinate }) => `${iconVerticalCoordinate}%`};
  left: ${({ iconHorizontalCoordinate }) => `${iconHorizontalCoordinate}%`};
  right: auto;
  bottom: auto;
  width: max-content;
  height: auto;
  z-index: 1;
`;

export const HotspotButton = styled.button`
  display: inline-block;
  width: max-content;
  max-width: none;
  min-width: 0;
  height: ${({ height }) => `${height}px`};
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  appearance: none;
  -webkit-appearance: none;
  -webkit-tap-highlight-color: transparent;
  cursor: pointer;
  transition: transform 0.35s ease-in-out, fill 0.35s ease-in-out;

  &:hover, &:focus {
    transition: transform 0.35s ease-in-out, fill 0.35s ease-in-out;
    transform: scale(1.5);

    svg {
      transition: fill 0.35s ease-in-out;
      fill: ${({ colorProfile }) => themeUtil(Prop.ICON_HOVER, CPNT, colorProfile)};
      color: ${({ colorProfile }) => themeUtil(Prop.ICON_HOVER, CPNT, colorProfile)};
    }
  }

  &:focus {
    outline: 2px solid ${({ colorProfile }) => themeUtil(Prop.ICON_HOVER, CPNT, colorProfile)};
    outline-offset: 2px;
  }
`;

export const HotspotIcon = styled(Icon)`
  display: block;
  width: auto;
  height: ${({ height }) => `${height}px`};

  svg {
    width: auto;
    height: 100%;
    fill: ${({ colorProfile }) => themeUtil(Prop.ICON, CPNT, colorProfile)};
    color: ${({ colorProfile }) => themeUtil(Prop.ICON, CPNT, colorProfile)};
  }
`;

export const ActiveHotspotModal = styled.div`
  position: relative;
  grid-area: 1/1;
  height: 100%;
  width: 100%;
`;
